import React, { type PropsWithChildren, useRef, useState } from 'react';
import { Link } from 'react-router-dom';

import type { PromotedEntities } from '../../../BettingMenu/types';
import type { AnyMenuItem } from 'app/modules/Navigation/types';

import { useTranslation } from 'app/lang';
import { scrollToUnion } from 'app/modules/BettingMenu/utils';
import { getDictionaryDataItems } from 'app/modules/Navigation/utils';

import type { MenuItemTestDataAttributes } from '../../test-data-helpers';

type MenuItemProps = {
  entry: AnyMenuItem;
  promotedEntities?: PromotedEntities;
  promotedEntityId?: string;
  testDataAttributes: MenuItemTestDataAttributes;
  to: string;
  classNameItem?: string;
  classNameLink?: string;
  innerList?: JSX.Element;
};

export const MenuItem: React.FC<PropsWithChildren<MenuItemProps>> = ({
  entry,
  promotedEntities,
  promotedEntityId,
  classNameItem,
  classNameLink,
  children,
  testDataAttributes,
  to,
  innerList,
}) => {
  const { t } = useTranslation();
  const [showInnerList, setShowInnerList] = useState(true);
  const unionRef = useRef<HTMLLIElement>(null);

  if (promotedEntities && entry.key in promotedEntities) {
    promotedEntities[entry.key] = unionRef;
  }

  const onClick = () => {
    if (promotedEntities && promotedEntityId) {
      scrollToUnion(promotedEntities, promotedEntityId);
    }

    if (innerList) {
      setShowInnerList((preState) => !preState);
    }
    else {
      setShowInnerList(true);
    }
  };

  return (
    <li ref={unionRef}
        className={classNameItem}
        data-test="favorite-tournament">
      {entry.disabled ? (
        <a title={getDictionaryDataItems(t, entry.title)}
           className={classNameLink}
           onClick={onClick}
           {...entry.dataGaValues}
           {...testDataAttributes}>
          {children}
        </a>
      ) : (
        <Link
          to={to}
          title={getDictionaryDataItems(t, entry.title)}
          className={classNameLink}
          onClick={onClick}
          {...entry.dataGaValues}
          {...testDataAttributes}>
          {children}
        </Link>
      )}
      {showInnerList && innerList}
    </li>
  );
};
